import { store } from "../../redux/store/setup";

const webPath= "./web/"
const tabPath= "./tab/"
const mobilePath= "./mobile/"

// Function to get the current location from Redux store
const getTdsLocation = () => {
  const state = store.getState();
  return state.appReducer?.tdsLocationSelected || '';
};

export const backgroundTdsArr = [
    {
      get webUri() {
        return getTdsLocation() === 'TdsScoctland' 
          ? require(webPath+'tdsScotland.png') 
          : require(webPath+'tdsEngland.png');
      },
      get tabUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(tabPath+'tdsScotland.png')
          : require(tabPath+'tdsEngland.png');
      },
      get mobileUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(mobilePath+'tdsScotland.png')
          : require(mobilePath+'tdsEngland.png');
      },
      webStyle: {},
      tabStyle: {},
      mobileStyle: {},
    },
  ];
  
  export const backgroundTdsArrMainPage = [
    {
      get webUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(webPath+'tdsEngland1.png')
          : require(webPath+'tdsEngland1.png');
      },
      get tabUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(tabPath+'tdsScotland.png')
          : require(tabPath+'tdsEngland.png');
      },
      get mobileUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(mobilePath+'tdsScotland.png')
          : require(mobilePath+'tdsEngland.png');
      },
      webStyle: {},
      tabStyle: {},
      mobileStyle: {},
    },
  ];
  
  export const backgroundTdsArrBackPage = [
    {
      get webUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(webPath+'backScotland.png')
          : require(webPath+'back.png');
      },
      get tabUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(tabPath+'tdsScotland.png')
          : require(tabPath+'tdsEngland.png');
      },
      get mobileUri() {
        return getTdsLocation() === 'TdsScoctland'
          ? require(mobilePath+'tdsScotland.png')
          : require(mobilePath+'tdsEngland.png');
      },
      webStyle: {},
      tabStyle: {},
      mobileStyle: {},
    },
  ];